/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { useTranslation } from '../../../i18n';

import { selectors as fromRates } from '../../../entities/rates';
import { SweetModal } from '../../ui/modal/sweet-modal';

const MAX_TAXES_PRICE = 100;

export const DeclarationModal: React.FC = () => {
  const [t] = useTranslation('rates');

  const [opened, setOpen] = useState(false);
  const [remember, setRemember] = useState(false);

  const price: number = useSelector(fromRates.getDeclarationFullPrice);

  useEffect(() => {
    if (!remember && price > MAX_TAXES_PRICE) {
      setOpen(true);
    }
  }, [price, remember]);

  const handleClose = useCallback(() => {
    setOpen(false);
    setRemember(true);
  }, []);

  if (opened) {
    return (
      <SweetModal open={opened} onClose={handleClose}>
        <h2>{t('rates.declaration.taxesLimit.header')}</h2>
        <div
          className="text-left"
          dangerouslySetInnerHTML={{
            __html: t('rates.declaration.taxesLimit.description', {
              amount: `${price} EUR`,
              taxLimit: `${MAX_TAXES_PRICE} EUR`,
            }),
          }}
        />
      </SweetModal>
    );
  }

  return null;
};
